var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { Switch } from "antd";
import { connect } from "react-redux";
import { getSystemCreatedTrackedItemTypes, inActivateTrackedItemType, activateTrackedItemType, } from "../../../../../../../redux/tracked-item-type/actions";
import { useHistory } from "react-router-dom";
import { editTrackedItemTypeRoute } from "../../../../../../../core/constants/routesPath";
import localize from "../../../../../../../core/utils/translation-files";
import TableActions from "../../../../../../../layout/components/customTable/tableActions";
import { notifications } from "../../../../../../../layout/components/notifications";
import { ResponseStatusCodes } from "../../../../../../../core/constants/responseStatusCodes";
import { SystemCreatedTrackedItemTypeTable } from "./components/systemCreatedtrackedItemsTypeTable";
import UseCustomPagination from "../../../../../../../layout/components/hooks/useCustomPagination";
import { TrackedItemsVariables } from "../../../../../../../core/constants/TrackedItemsConstants";
const SystemCreatedTypesListingContainer = ({ getSystemCreatedTrackedItemTypes, inActivateTrackedItemType, activateTrackedItemType, benchmarkListOptions, systemCreatedTrackedItemTypes, isPrintMode, selectedTag, lastActionType, paginationMetadata, resetSearch }) => {
    var _a, _b;
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(1);
    const queryParams = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.queryParams;
    const sortOrderAlias = {
        ascend: "asc",
        descend: "desc",
    };
    const defaultSort = {
        sort: `name,${sortOrderAlias.ascend}`,
    };
    const useServerPagination = true; // Always use server-side pagination for Tab 2
    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
    const _c = UseCustomPagination({
        // totalRecords: !useServerPagination 
        //   ? (paginationMetadata?.totalPages || 0) * pageSize
        //   : systemCreatedTrackedItemTypes?.length ?? 0,
        clientPagination: !useServerPagination,
        stateParams: true,
        totalRecords: (_b = paginationMetadata === null || paginationMetadata === void 0 ? void 0 : paginationMetadata.totalElements) !== null && _b !== void 0 ? _b : 0,
        sortCallback: resetSearch()
    }), { handleCustomTablePropChange } = _c, restPaginationProps = __rest(_c, ["handleCustomTablePropChange"]);
    const searchValue = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.searchInput) || "";
    // Initial load for server-side pagination
    useEffect(() => {
        if (!useServerPagination)
            return;
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        const hasSearchInput = trimmedSearch.length > 0;
        const meetsMinimumLength = trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH;
        const hasTag = !!selectedTag;
        // Only do initial load if there's no search and no tag
        if (!hasSearchInput && !hasTag && !(systemCreatedTrackedItemTypes === null || systemCreatedTrackedItemTypes === void 0 ? void 0 : systemCreatedTrackedItemTypes.length) && (restPaginationProps === null || restPaginationProps === void 0 ? void 0 : restPaginationProps.pageSize) !== 0) {
            getSystemCreatedTrackedItemTypes(Object.assign({ page: 0, size: restPaginationProps === null || restPaginationProps === void 0 ? void 0 : restPaginationProps.pageSize }, ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.sort) ? { sort: `${queryParams.sort},${sortOrderAlias[queryParams.order]}` } : defaultSort)));
        }
        setInitialLoadCompleted(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        const hasSearchInput = trimmedSearch.length > 0;
        const meetsMinimumLength = trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH;
        const hasTag = !!selectedTag;
        if (hasSearchInput && !meetsMinimumLength && !hasTag) {
            return;
        }
        let searchTypeParam;
        let keywordParam;
        if (hasSearchInput && hasTag) {
            if (lastActionType === "tag") {
                searchTypeParam = "reportTypeTag";
                keywordParam = selectedTag || "";
            }
            else {
                searchTypeParam = "reportTypeName";
                keywordParam = trimmedSearch;
            }
        }
        else if (hasTag) {
            searchTypeParam = "reportTypeTag";
            keywordParam = selectedTag || "";
        }
        else if (meetsMinimumLength) {
            searchTypeParam = "reportTypeName";
            keywordParam = trimmedSearch;
        }
        // For server pagination, only make API call if there's a search/tag or if we're not on initial load
        if (useServerPagination &&
            !searchTypeParam &&
            !keywordParam &&
            !(systemCreatedTrackedItemTypes === null || systemCreatedTrackedItemTypes === void 0 ? void 0 : systemCreatedTrackedItemTypes.length) &&
            !initialLoadCompleted) {
            return; // Initial load is handled by the initial load effect
        }
        const params = searchTypeParam && keywordParam
            ? Object.assign({ keyword: keywordParam, searchType: searchTypeParam }, (useServerPagination && { page: currentPage - 1, size: restPaginationProps.pageSize })) : useServerPagination
            ? { page: currentPage - 1, size: restPaginationProps.pageSize }
            : undefined;
        if ((restPaginationProps === null || restPaginationProps === void 0 ? void 0 : restPaginationProps.pageSize) !== 0) {
            getSystemCreatedTrackedItemTypes(Object.assign(Object.assign({}, params), ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.sort) ? { sort: `${queryParams.sort},${sortOrderAlias[queryParams.order]}` } : defaultSort)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPage,
        restPaginationProps.pageSize
    ]);
    const inActivateTrackedItemTypeHandler = (data) => {
        inActivateTrackedItemType(data).then((response) => {
            if (response &&
                response.code === ResponseStatusCodes.DATA_CONSTRAINT_VIOLATION) {
                return;
            }
            else {
                notifications.success(localize(["TrackedItem.default", "disabled", "successfully"]));
            }
        });
    };
    const activateTrackedItemTypeHandler = (data) => {
        activateTrackedItemType(data).then((response) => {
            if (response &&
                response.code === ResponseStatusCodes.DATA_CONSTRAINT_VIOLATION) {
                return;
            }
            else {
                // getTrackedItemsPerSite().catch((error) => {
                //   throw error;
                // });
                notifications.success(localize(["TrackedItem.default", "enabled", "successfully"]));
            }
        });
    };
    const editTrackedItemTypeRedirect = (trackedItem) => {
        history.push(editTrackedItemTypeRoute + trackedItem.id, {
            reportTypeId: trackedItem.id,
            systemCreated: true,
        });
    };
    const trackedItemTypeActions = (trackedItemType) => {
        const actionArray = [
            {
                priority: 2,
                title: ["edit", "TrackedItem.default"],
                onClick: editTrackedItemTypeRedirect.bind({}, trackedItemType),
                svgIcon: "Edit",
            },
            {
                priority: 1,
                title: trackedItemType.disabled === true
                    ? ["unArchive", "TrackedItem.default"]
                    : ["archive", "TrackedItem.default"],
                isModal: true,
                modalTitle: [
                    "areYouSureTo",
                    `${trackedItemType.disabled === true ? ["unarchive"] : ["Archive"]}`,
                    "TrackedItem.thisDefault?",
                ],
                onConfirm: trackedItemType.disabled === true
                    ? activateTrackedItemTypeHandler.bind({}, trackedItemType)
                    : inActivateTrackedItemTypeHandler.bind({}, trackedItemType),
                disbaled: trackedItemType.itemSubCategoryId === -1,
                children: (React.createElement(Switch, { className: "ml-1", checked: trackedItemType.disabled === false, disabled: trackedItemType.itemSubCategoryId === -1 })),
            },
        ];
        return React.createElement(TableActions, { actionArray: actionArray });
    };
    const handlePageChange = (page) => {
        if (useServerPagination) {
            setCurrentPage(page);
        }
        else {
            restPaginationProps.handleChangePage(page);
        }
    };
    return (React.createElement("div", null,
        React.createElement(SystemCreatedTrackedItemTypeTable, { data: systemCreatedTrackedItemTypes, actions: trackedItemTypeActions, benchmarkListOptions: benchmarkListOptions, currentPage: useServerPagination ? currentPage : restPaginationProps.currentPage, pageSize: restPaginationProps === null || restPaginationProps === void 0 ? void 0 : restPaginationProps.pageSize, handleCustomTablePropChange: handleCustomTablePropChange, paginationSection: Object.assign(Object.assign({}, restPaginationProps), (useServerPagination && {
                currentPage: currentPage,
                pageSize: restPaginationProps.pageSize,
                totalRecords: (paginationMetadata === null || paginationMetadata === void 0 ? void 0 : paginationMetadata.totalElements) || 0,
                handleChangePage: handlePageChange,
            })), isPrintMode: isPrintMode, serverPagination: useServerPagination, totalCount: useServerPagination ? (paginationMetadata === null || paginationMetadata === void 0 ? void 0 : paginationMetadata.totalElements) || 0 : undefined })));
};
function mapStateTopProps(state) {
    var _a, _b, _c;
    return {
        systemCreatedTrackedItemTypes: (_a = state.trackedItemTypes) === null || _a === void 0 ? void 0 : _a.systemCreatedTrackedItems,
        isPrintMode: (_b = state.togglePrint) === null || _b === void 0 ? void 0 : _b.status,
        paginationMetadata: (_c = state.trackedItemTypes) === null || _c === void 0 ? void 0 : _c.systemCreatedTrackedItemPagination,
    };
}
const mapDispatchToProps = {
    inActivateTrackedItemType,
    activateTrackedItemType,
    getSystemCreatedTrackedItemTypes,
};
SystemCreatedTypesListingContainer.propTypes = {};
export default connect(mapStateTopProps, mapDispatchToProps)(SystemCreatedTypesListingContainer);
